// magic `index` in CommonJS pattern
// it can be required by just requiring the folder
// also for assets pipeline :)
import ActiveSwitches from "./mark-switch-active"
import GoogleMapDiv from "./google-map"
import OverlayToggle from "./overlay-toggle"
import Carousel from "concepts/new_development_buildings/carousel/index"
import _once from "lodash/once"

const init = _once(() => {
  ActiveSwitches.instance()
  OverlayToggle.instance()
  GoogleMapDiv.instance()
  Carousel.init()
})

export default { init }
